import { AsteriskCircleOutlineIcon } from './AsteriskCircleOutlineIcon';

/**
 * author: mocking-mike
 * id 1A9A6BE7-2B58-458C-9DA5-3CCA65D67414
 * name asterisk-circle-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/asterisk-circle-outline.svg
 * tags
 */
export const RequiredCircleIcon = AsteriskCircleOutlineIcon;
export default RequiredCircleIcon